var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    { class: { "mobile-responsive": _vm.isMobile }, attrs: { id: "sidebar" } },
    [
      _c(
        "ul",
        {
          staticClass: "content",
          style: { backgroundColor: _vm.backgroundColor }
        },
        [
          _vm._l(_vm.options, function(value, key) {
            return _c(
              "li",
              {
                key: key,
                class: [
                  (_vm.currentPage == value.navigationPath &&
                    _vm.currentPage != "/") ||
                  (_vm.currentPage == "/" &&
                    value.navigationPath == "/dashboard")
                    ? "active"
                    : ""
                ],
                on: {
                  click: function($event) {
                    return _vm.onCloseSidebar(value)
                  }
                }
              },
              [
                _c("router-link", { attrs: { to: value.navigationPath } }, [
                  _c("span", [_c("i", { class: value.iconClasses })]),
                  _c("label", [_vm._v(_vm._s(value.title))])
                ])
              ],
              1
            )
          }),
          _vm.isMobile ? _c("li", [_c("compact-header-menu")], 1) : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }